@import 'apps/webcomponents/src/assets/widget-shared.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import 'apps/webcomponents/src/assets/flexbox-helpers.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';

.loading-template {
  width: 100%;
  height: 100%;

  gz-push-body-layout::part(header) {
    padding-left: calc(var(--spacer) * 1);
  }

  gz-loader[class*='title-loader'],
  gz-loader[class*='filter-loader'],
  gz-loader[class*='actions-loader'] {
    width: 240px;
  }

  gz-loader[class='icon-loader'] {
    width: 24px;
  }

  gz-loader[class='smartview-title-loader'] {
    width: 120px;
  }

  gz-progress-spinner[class='spinner-dashboard'] {
    width: auto;
  }

  .buttons-loader-container {
    width: 144px;
    justify-content: space-between;
  }

  .filter-loader-container {
    padding: calc(2.5 * var(--spacer)) calc(var(--spacer) * 2.5);
  }

  .separator {
    height: calc(var(--spacer) * 2);
    width: 1px;
    margin: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 0.5);
    background-color: var(--chart-101-pressed-dividers);
  }

  .dashboard-loading {
    height: calc(100vh - 100px);
  }

  #dashboard-toolbar {
    height: calc(var(--spacer) * 5);
    padding: 0 calc(var(--spacer) * 2.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.error-text {
  color: var(--body-text-arrows-400);

  .title {
    margin-bottom: var(--spacer);
  }
}

.feedback-toolbar {
  gz-loader[class*='title-loader'] {
    padding: calc(var(--spacer) * 1.3) 0 calc(var(--spacer) * 2.5) calc(var(--spacer) * 2.5);
  }
}

.wrapper {
  background: var(--white-layout-301-level-0-elevation);
}

:host([data-display-mode='pdf']) {
  --gridStackManager-overflow: visible !important;

  #dashboard-grid-stack {
    overflow: visible !important;
  }
}
